import { PageHeader, Empty } from "../components/common";
import { MySteps, useMySteps } from "../components/MySteps";

export default function MyStepsPage() {
  const [d, load] = useMySteps();
  return (
    <div className="max-w-4xl">
      <PageHeader eyebrow="Your work" title="My tasks" desc="Steps on production plans that are given to you. Start them, mark them done and add notes; the next step moves on for production." />
      {!d ? <div className="text-sm text-muted-foreground">Loading…</div> : !d.items.length && !d.recent?.length
        ? <Empty text="No steps are given to you right now." />
        : <MySteps title="Your steps" data={d} reload={load} />}
    </div>
  );
}
